"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Picture() {
    return (react_1.default.createElement("svg", { width: "56", height: "56", viewBox: "0 0 56 56" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("rect", { width: "56", height: "56" }),
            react_1.default.createElement("rect", { width: "50", height: "42", x: "3", y: "7", fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2" }),
            react_1.default.createElement("polygon", { fill: "#FFF", points: "17.058 49.033 53.012 49.033 53.012 37.077 41 24.945" }),
            react_1.default.createElement("rect", { width: "50", height: "42", x: "3", y: "7", stroke: "#BFBFBF", strokeWidth: "2" }),
            react_1.default.createElement("polyline", { stroke: "#BFBFBF", strokeWidth: "2", points: "25.904 60.402 25.904 25.277 43.114 25.277", transform: "rotate(45 34.509 42.84)" }),
            react_1.default.createElement("circle", { cx: "16", cy: "20", r: "5", fill: "#FFF", stroke: "#BFBFBF", strokeWidth: "2" }))));
}
exports.default = Picture;
//# sourceMappingURL=Picture.js.map